
  import { Component, Vue } from 'vue-property-decorator'

  import DemoCartWidget from '@/components/cart/DemoCartWidget.vue'
  import Price from '@/components/elements/Price.vue'
  import { LanguageStrings } from '@/language/types'

  @Component({
    name: 'MobileDemoCartWidget',
    components: {
      DemoCartWidget,
      Price,
    },
  })
  export default class MobileDemoCartWidget extends Vue {
    t: LanguageStrings['mobileCartWidget']
    resizeObserver: ResizeObserver

    get bundleCartItems() {
      return [
        {
          id: 'total-experience-bundle',
          name: 'Total Experience',
          image: {
            url: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=300&h=200&fit=crop&crop=center',
            alt: 'Total Experience Bundle',
          },
          isAnchor: true,
          isMembershipEvent: false,
          isBundle: true,
          bundleItems: [
            {
              name: 'General Admission',
              price: 50.0, // $50.00 (2 adults × $25.00)
              time: null,
              sessionTime: 'Sun 16 Nov @ 10:00 AM',
              types: [
                {
                  type: {
                    id: 'adult-ticket',
                    name: 'Adult',
                  },
                  group: {
                    name: 'General Admission',
                  },
                  ticketCount: 2,
                  totalPrice: 50.0,
                  name: 'Adult',
                },
              ],
            },
            {
              name: 'Bugs Lab Exhibition',
              price: 20.0, // $20.00 (2 adults × $10.00)
              time: 'Anytime',
              sessionTime: 'Sun 16 Nov @ 2:00 PM',
              types: [
                {
                  type: {
                    id: 'adult-ticket',
                    name: 'Adult',
                  },
                  group: {
                    name: 'Bugs Lab Exhibition',
                  },
                  ticketCount: 2,
                  totalPrice: 20.0,
                  name: 'Adult',
                },
              ],
            },
            {
              name: 'Space: A New Frontier 3D Film',
              price: 16.0, // $16.00 (2 adults × $8.00)
              time: '10:00 AM',
              sessionTime: 'Sun 16 Nov @ 4:00 PM',
              types: [
                {
                  type: {
                    id: 'adult-ticket',
                    name: 'Adult',
                  },
                  group: {
                    name: 'Space: A New Frontier 3D Film',
                  },
                  ticketCount: 2,
                  totalPrice: 16.0,
                  name: 'Adult',
                },
              ],
            },
          ],
          types: [
            {
              type: {
                id: 'bundle-ticket',
                name: 'Total Experience',
              },
              group: {
                name: 'Bundle',
              },
              ticketCount: 1,
              totalPrice: 86.0, // $86.00 ($50 + $20 + $16)
              name: 'Total Experience',
            },
          ],
        },
      ]
    }

    mounted() {
      const footerEl = this.$refs.footer as HTMLElement
      const style = document.body.style

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          const height = footerEl.offsetHeight
          // When the element is hidden, the height is 0,
          // so we don't need to update the css prop
          if (height > 0) {
            style.setProperty('--mobile-demo-cart-footer-height', `${height}px`)
          }
        })

        this.resizeObserver.observe(footerEl)
      }
    }

    get hideCheckoutButton() {
      return this.$route.name === 'checkout'
    }

    close() {
      this.$modals.close()
    }

    get moreEventsLinkProps() {
      return this.$route.name === 'events'
        ? { tag: 'button', class: 'button secondary more-events-button' }
        : { tag: 'a', class: 'more-events-button' }
    }
  }
